import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Auth } from 'aws-amplify';
import {
  localImages,
  stringsList,
  navigationConstants,
} from '../../../../dashboard/constants/app-config';
import { FolderService } from '../../invoices/services/folder.service';
import { log } from 'console';
import { TF } from 'src/app/API.service';

interface IDialogData {
  isEdit: boolean;
  folderId: string;
  currentFolders: any;
  parentFolderID?: string;
}

@Component({
  selector: 'app-create-folder-dialog',
  templateUrl: './create-folder-dialog.component.html',
  styleUrls: [
    './create-folder-dialog.component.css',
    '../../../styles/styles.css',
  ],
})
export class CreateFolderDialogComponent implements OnInit {
  folderName: string = '';
  stringsList = stringsList;
  localImages = localImages;
  folderAlreadyExists: boolean = false;
  user!: any;
  creating: boolean = false;
  constructor(
    private folderService: FolderService,
    public dialogRef: MatDialogRef<CreateFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IDialogData
  ) {}

  ngOnInit(): void {
    this.getInitialData();
  }

  createFolder() {
    const folderExists = this.dialogData?.currentFolders.some(
      (folder: any) => folder.name === this.folderName
    );
    if (folderExists) {
      // Handle folder name already exists case (e.g., show error message)
      this.creating = false;
      this.folderAlreadyExists = true
      return;
    }

    this.creating = true;
    let newFolder = {
      name: this.folderName.trim(),
      clientID: this.user.attributes.sub,
      parentFolderID: this.dialogData.parentFolderID,
    };
    this.folderService
      .CreateFolder(newFolder)
      .then((data: any) => {
        data.type = 'folder';
       data.latestScanType =  this.determineIfGoodsAndMaterial(data)
        this.creating = false;
        this.dialogRef.close(data);
      })
      .catch((err) => console.log(err));
  }

    determineIfGoodsAndMaterial(folder: any): string {
      return folder.isLatestScanIncludedProducts === TF.TRUE
        ? 'Goods and Material'
        : 'Regular';
    }

  get isEdit(): boolean {
    return this.dialogData.isEdit;
  }

  async getInitialData(): Promise<void> {
    try {
      if (this.dialogData.isEdit) {
        const [user, folder] = await Promise.all([
          Auth.currentAuthenticatedUser(),
          this.folderService.GetFolder(this.dialogData.folderId),
        ]);
        this.folderName = folder.name;
        this.user = user;
      } else {
        const [user] = await Promise.all([Auth.currentAuthenticatedUser()]);
        this.user = user;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async editFolder() {
    try {
      const editedFolder = {
        name: this.folderName,
        id: this.dialogData.folderId,
      };
      const data = await this.folderService.UpdateFolder(editedFolder);
      this.dialogRef.close();
    } catch (e) {
      console.log(e);
    }
  }

  submitFolderAction() {
    if (this.isEdit) {
      this.editFolder();
    } else {
      this.createFolder();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
